import { EmptyState, FlexColumn, Loading, useLoading } from '@gorila-shared-ui/components';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { useRecoilValue, useResetRecoilState, useSetRecoilState } from 'recoil';
import { useStyles } from '../../../hooks/useStyles';
import useUpdateEffect from '../../../hooks/useUpdateEffect';
import { getDeliveryReports } from '../../../services/reportsService';
import { apiParamsState, isAllWorkspacesSelect } from '../../../storage/app';
import {
  delivertReportState,
  deliveryAllDevicesState,
  deliveryDateState,
  deliveryReportStates,
  reportFilterGroupState,
  updateReportState,
} from '../../../storage/reports';
import { DeliveryReport } from '../../../types/reports';
import DeliveryReportTable from './DeliveryReportTable';

function DeliveryReportsByGroup() {
  const { css } = useStyles();
  const { loading, startLoading, stopLoading } = useLoading();
  const [page, setPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const apiParams = useRecoilValue(apiParamsState);
  const date = useRecoilValue(deliveryDateState);
  const groupId = useRecoilValue(reportFilterGroupState);
  const isAllWorkspacesSelected = useRecoilValue(isAllWorkspacesSelect);
  const resetDeliveryReports = useResetRecoilState(deliveryReportStates);
  const setDeliveryAllDevices = useSetRecoilState(deliveryAllDevicesState);
  const setDeliveryReports = useSetRecoilState(deliveryReportStates);
  const states = useRecoilValue(delivertReportState(groupId));
  const updateReport = useRecoilValue(updateReportState);

  useEffect(() => {
    return () => {
      resetDeliveryReports();
    };
  }, []);

  useUpdateEffect(() => {
    if (!date || !apiParams || !groupId) return;
    setPage(0);
  }, [groupId, date, apiParams?.clientId, isAllWorkspacesSelected, apiParams?.subClientId]);

  useEffect(() => {
    if (!apiParams?.clientId || !groupId) return;
    if (page === 0) {
      setPage(1);
      return;
    }
    const loadDeliveryReports = async () => {
      startLoading();
      const { reports, allDevicesDocument, total, error } = await getDeliveryReports({
        page,
        groupId,
        clientId: apiParams.clientId,
        date: moment(date).format('YYYYMMDD'),
        subClientId: isAllWorkspacesSelected ? undefined : apiParams.subClientId,
      });
      setTotalItems(total || 0);
      setDeliveryAllDevices(allDevicesDocument);
      const newReports: { [key: string]: DeliveryReport[] } = {};
      if (!error) {
        newReports[groupId] = reports ?? [];
      }
      setDeliveryReports(newReports);
      stopLoading();
    };

    loadDeliveryReports();
  }, [page, updateReport]);

  if (loading) {
    return <Loading />;
  }

  if (!groupId) {
    return <EmptyState title="Selecciona un grupo para visualizar el reporte." />;
  }

  return (
    <FlexColumn
      gap={0}
      classNames={css({ flex: 1, overflow: 'hidden' })}
    >
      <DeliveryReportTable
        states={states}
        page={page}
        totalItems={totalItems}
        onPageChange={setPage}
        extended
      />
    </FlexColumn>
  );
}

export default DeliveryReportsByGroup;
